'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  label: 'SH_NewHireOnBoard',
  isOpen: false,
  title: '新建報到',
  enable: true,
  subMenu: [{
    label: 'SH_CreatePersonnelFile',
    title: 'Foundation - 建立人事資料',
    isOpen: false,
    prefix: '1.',
    subMenu: [{
      label: [{
        id: 'SH_UseGuideL2Intro',
        defaultMessage: '開始前，請您先確認並備妥以下資訊：',
        type: ''
      }, {
        id: 'SH_UseGuideL2Intro01',
        defaultMessage: '1. 人員基本資料',
        type: 'bulletPoint',
        prefix: ''
      }, {
        id: 'SH_UseGuideL2Intro02',
        defaultMessage: '2. 工號編碼方式',
        type: 'bulletPoint',
        prefix: ''
      }, {
        id: 'SH_GetStarted',
        defaultMessage: '開始操作(/foundation/hire)',
        type: 'url',
        link: '/foundation/hire'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'FD_CreateRegister',
        defaultMessage: '新建報到',
        type: '',
        prefix: '(1)'
      }, {
        id: 'SH_UseGuideL3Intro01',
        defaultMessage: '設定報到日期並開始建立人事資料',
        type: 'content'
      }],
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_ConfirmEmployeeData',
        defaultMessage: '確認員工資料',
        type: '',
        prefix: '(2)'
      }, {
        id: 'SH_UseGuideL3Intro02',
        defaultMessage: '填寫人員個資及職務相關資料',
        type: 'content'
      }],
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_HireOnBoardList',
        defaultMessage: 'Hire 報到清單管理',
        type: '',
        prefix: '(3)'
      }, {
        id: 'SH_UseGuideL3Intro03',
        defaultMessage: '選定人員開始報到作業',
        type: 'content'
      }],
      isOpen: false,
      subMenu: []
    }]
  }, {
    label: 'SH_SetAttendanceRules',
    title: 'Attendance - 建立人員出勤規範',
    isOpen: false,
    prefix: '2.',
    subMenu: [{
      label: [{
        id: 'SH_UseGuideL2Intro',
        defaultMessage: '開始前，請您先確認並備妥以下資訊：',
        type: ''
      }, {
        id: 'SH_UseGuideL2Intro03',
        defaultMessage: '人員適用班別、出勤規則及打卡規則',
        type: 'bulletPoint'
      }, {
        id: 'SH_UseGuideL2Intro04',
        defaultMessage: '人員特定之休假規則',
        type: 'bulletPoint'
      }, {
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/ta/manager/staffbasicinfo'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'PT_EmployeeInformation',
        defaultMessage: '人員基本資料',
        type: '',
        prefix: '(1)'
      }, {
        id: 'SH_UseGuideL3Intro04',
        defaultMessage: '於異動紀錄建立異動單，選定班別及出勤規則，並設定打卡規則',
        type: 'content'
      }],
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'PT_GenerateLeaveHours',
        defaultMessage: '產生假別時數',
        type: '',
        prefix: '(2)'
      }, {
        id: 'SH_UseGuideL3Intro05',
        defaultMessage: '假別時數依照出勤規則設定發放',
        type: 'content'
      }],
      isOpen: false,
      subMenu: []
    }]
  }, {
    label: 'SH_SetSalaryInsurance',
    title: 'Payroll - 建立人員薪資保險資料',
    isOpen: false,
    prefix: '3.',
    subMenu: [{
      label: [{
        id: 'SH_UseGuideL2Intro',
        defaultMessage: '開始前，請您先確認並備妥以下資訊：',
        type: ''
      }, {
        id: 'SH_UseGuideL2Intro05',
        defaultMessage: '薪資條件細節：薪資制度、薪資範圍',
        type: 'bulletPoint',
        prefix: ''
      }, {
        id: 'SH_UseGuideL2Intro06',
        defaultMessage: '勞健保(含眷屬)投保資訊',
        type: 'bulletPoint',
        prefix: ''
      }, {
        id: 'SH_UseGuideL2Intro07',
        defaultMessage: '所得稅(含眷屬)申報資訊',
        type: 'bulletPoint',
        prefix: ''
      }],
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'PY_EmpSalaryAndInsuranceData',
        defaultMessage: '員工薪資保險資料',
        type: '',
        prefix: '(1)'
      }, {
        id: 'SH_UseGuideL3Intro06',
        defaultMessage: '新增表單以建立人員薪資主檔，並設定人員保險、所得稅資料',
        type: 'content'
      }, {
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/payroll/masterdata/salary'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_HealthInsuranceDependentsData',
        defaultMessage: '健保眷屬投保資料',
        type: '',
        prefix: '(2)'
      }, {
        id: 'SH_UseGuideL3Intro07',
        defaultMessage: '新增眷屬資料以進行加保作業',
        type: 'content'
      }, {
        id: 'SH_GetStarted',
        defaultMessage: '勞健保(含眷屬)投保資訊',
        type: 'url',
        link: '/payroll/masterdata/nhidependentsinsure'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_IncomeTaxDependentsData',
        defaultMessage: '所得稅扶養親屬資料',
        type: '',
        prefix: '(3)'
      }, {
        id: 'SH_UseGuideL3Intro08',
        defaultMessage: '新增眷屬資料以進行扶養親屬認列作業',
        type: 'content'
      }, {
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/payroll/masterdata/incometaxdependents'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }]
  }, {
    label: 'SH_AccountSetup',
    title: '帳號設定',
    isOpen: false,
    prefix: '4.',
    subMenu: [{
      label: [{
        id: 'SH_UseGuideL2Intro',
        defaultMessage: '開始前，請您先確認並備妥以下資訊：',
        type: ''
      }, {
        id: 'SH_UseGuideL2Intro08',
        defaultMessage: '人員已開啟之有效信箱資訊',
        type: 'bulletPoint'
      }, {
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/foundation/setting/accountmanagement'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_EditAccountInfo',
        defaultMessage: '管理功能設定帳號 Email',
        type: ''
      }, {
        id: 'SH_UseGuideL3Intro09',
        defaultMessage: '輸入人員 Email 作為登入帳號',
        type: 'content'
      }],
      isOpen: false,
      subMenu: []
    }]
  }]
}, {
  label: 'SH_Termination',
  isOpen: false, // 添加 isOpen 状态以控制内层菜单的展开和收起
  title: '離職',
  enable: true,
  subMenu: [{
    label: 'SH_CreateTerminationForm',
    title: '建立離職異動單',
    isOpen: false,
    prefix: '1.',
    subMenu: [{
      label: [{
        id: 'SH_UseGuideL2Intro',
        defaultMessage: '開始前，請您先確認並備妥以下資訊：',
        type: ''
      }, {
        id: 'SH_UseGuideL2Intro09',
        defaultMessage: '人員離職日期(=最後工作日)',
        type: 'bulletPoint',
        prefix: ''
      }, {
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/foundation/PA_zh_tw'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_CreateEmployeeChangeForm',
        defaultMessage: 'People+ 建立異動單',
        type: '',
        prefix: '(1)'
      }, {
        id: 'SH_UseGuideL3Intro10',
        defaultMessage: '將生效日設定為離職日的隔天，異動行為選擇離職(生效當日起，該人員將無法登入系統)',
        type: 'content'
      }],
      isOpen: false,
      subMenu: []
    }]
  }, {
    label: 'SH_WithdrawalOperation',
    title: '退保作業',
    isOpen: false,
    prefix: '2.',
    subMenu: [{
      label: [{
        id: 'SH_UseGuideL2Intro',
        defaultMessage: '開始前，請您先確認並備妥以下資訊：',
        type: ''
      }, {
        id: 'SH_UseGuideL2Intro10',
        defaultMessage: '人員需退保項目',
        type: 'bulletPoint',
        prefix: ''
      }, {
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/payroll/masterdata/salary'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_CreateInsuranceForm',
        defaultMessage: '新增保險資料表單',
        type: '',
        prefix: '(1)'
      }, {
        id: 'SH_UseGuideL3Intro11',
        defaultMessage: '將生效日設定為離職日的隔天，狀態設定為退保',
        type: 'content'
      }],
      isOpen: false,
      subMenu: []
    }]
  }, {
    label: 'PT_AttendanceSummary',
    title: '結算作業',
    isOpen: false,
    prefix: '3.',
    subMenu: [{
      label: [{
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/ta/manager/billing/resign'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_CreateResignationSettlement',
        defaultMessage: '新增離職結算並產生資料',
        type: '',
        prefix: '(1)'
      }, {
        id: 'SH_UseGuideL3Intro12',
        defaultMessage: '建議將結算年度回推數年，以利檢查過往未結算之代金 ',
        type: 'content'
      }],
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro13',
        defaultMessage: '檢查「設定」內各分頁的資料',
        type: '',
        prefix: '(2)'
      }, {
        id: 'SH_UseGuideL3Intro14',
        defaultMessage: '\u8ACB\u5206\u5225\u6AA2\u67E5\u51FA\u52E4\u7570\u5E38\u3001\u73ED\u8868\u7D50\u7B97\u3001\u8ACB\u5047\u6263\u6B3E\u3001\u52A0\u73ED\u8CBB\u3001\u88DC\u4F11\u4EE3\u91D1\u3001\u4E0D\u4F11\u5047\u4EE3\u91D1\u51715\u500B\u5206\u9801\n                  \u2731 \u9078\u9805\u8AAA\u660E\uFF1A\n                  - \u7D50\u7B97\u62CB\u8F49\uFF1A\u6642\u6578\u5C07\u62CB\u8F49\u81F3 Payroll \u8A08\u7B97\u91D1\u984D\u3002\n                  - \u7D50\u7B97\u4E0D\u62CB\u8F49\uFF1A\u6642\u6578\u4E0D\u62CB\u8F49\u81F3 Payroll \u8A08\u7B97\u91D1\u984D\uFF0C\u4E14\u6B64\u6642\u6578\u4EA6\u9396\u5B9A\u4E0D\u53EF\u518D\u4F7F\u7528\u3002\n                  - \u4FDD\u7559\u53EF\u7528\u6642\u6578\uFF1A\u6642\u6578\u4E0D\u62CB\u8F49\u81F3 Payroll \u8A08\u7B97\u91D1\u984D\uFF0C\u4E14\u6B64\u6642\u6578\u4ECD\u53EF\u7E7C\u7E8C\u4F7F\u7528(\u82E5\u53EF\u7528\u6642\u9593\u5DF2\u5230\u671F\uFF0C\u9808\u4FEE\u6539\u671F\u9650\u65B9\u53EF\u7E7C\u7E8C\u4F7F\u7528)\u3002 ',
        type: 'content'
      }],
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_Transport',
        defaultMessage: '拋轉',
        type: '',
        prefix: '(3)'
      }, {
        id: 'SH_UseGuideL3Intro15',
        defaultMessage: '點擊「單項拋轉」後結算資料將移轉至 Payroll ',
        type: 'content'
      }],
      isOpen: false,
      subMenu: []
    }]
  }]
}, {
  label: 'PY_LeaveWithoutPay02',
  isOpen: false, // 添加 isOpen 状态以控制内层菜单的展开和收起
  title: '留職停薪/復職',
  enable: true,
  subMenu: [{
    label: 'SH_CreateLeaveWithoutPayForm',
    title: '建立留職異動單',
    isOpen: false,
    prefix: '1.',
    subMenu: [{
      label: [{
        id: 'SH_UseGuideL2Intro',
        defaultMessage: '開始前，請您先確認並備妥以下資訊：',
        type: ''
      }, {
        id: 'SH_UseGuideL2Intro12',
        defaultMessage: '人員最後工作日',
        type: 'bulletPoint',
        prefix: ''
      }, {
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/foundation/PA_zh_tw'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_CreateEmployeeChangeForm',
        defaultMessage: 'People+ 建立異動單',
        type: '',
        prefix: '(1)'
      }, {
        id: 'SH_UseGuideL3Intro16',
        defaultMessage: '將生效日設定為最後工作日的隔天，異動行為選擇留職(生效當日起，該人員將無法登入系統)',
        type: 'content'
      }],
      isOpen: false,
      subMenu: []
    }]
  }, {
    label: 'SH_WithdrawalOperation',
    title: '退保作業',
    isOpen: false,
    prefix: '2.',
    subMenu: [{
      label: [{
        id: 'SH_UseGuideL2Intro',
        defaultMessage: '開始前，請您先確認並備妥以下資訊：',
        type: ''
      }, {
        id: 'SH_UseGuideL2Intro10',
        defaultMessage: '人員需退保項目',
        type: 'bulletPoint',
        prefix: ''
      }, {
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/payroll/masterdata/salary'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_CreateInsuranceForm',
        defaultMessage: '新增保險資料表單',
        type: '',
        prefix: ''
      }, {
        id: 'SH_UseGuideL3Intro17',
        defaultMessage: '將生效日設定為最後工作日的隔天，狀態設定為退保',
        type: 'content'
      }],
      isOpen: false,
      subMenu: []
    }]
  }, {
    label: 'PT_AttendanceSummary',
    title: '結算作業',
    isOpen: false,
    prefix: '3.',
    subMenu: [{
      label: [{
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/ta/manager/billing/resign'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_CreateLeaveWithoutPaySettlement',
        defaultMessage: '新增留停結算並產生資料',
        type: '',
        prefix: '(1)'
      }, {
        id: 'SH_UseGuideL3Intro12',
        defaultMessage: '建議將結算年度回推數年，以利檢查過往未結算之代金 ',
        type: 'content'
      }],
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro13',
        defaultMessage: '檢查「設定」內各分頁的資料',
        type: '',
        prefix: '(2)'
      }, {
        id: 'SH_UseGuideL3Intro14',
        defaultMessage: '\n                \u8ACB\u5206\u5225\u6AA2\u67E5\u51FA\u52E4\u7570\u5E38\u3001\u73ED\u8868\u7D50\u7B97\u3001\u8ACB\u5047\u6263\u6B3E\u3001\u52A0\u73ED\u8CBB\u3001\u88DC\u4F11\u4EE3\u91D1\u3001\u4E0D\u4F11\u5047\u4EE3\u91D1\u51715\u500B\u5206\u9801<br>\n                \u2731 \u9078\u9805\u8AAA\u660E\uFF1A<br>\n                - \u7D50\u7B97\u62CB\u8F49\uFF1A\u6642\u6578\u5C07\u62CB\u8F49\u81F3 Payroll \u8A08\u7B97\u91D1\u984D\u3002<br>\n                - \u7D50\u7B97\u4E0D\u62CB\u8F49\uFF1A\u6642\u6578\u4E0D\u62CB\u8F49\u81F3 Payroll \u8A08\u7B97\u91D1\u984D\uFF0C\u4E14\u6B64\u6642\u6578\u4EA6\u9396\u5B9A\u4E0D\u53EF\u518D\u4F7F\u7528\u3002<br>\n                - \u4FDD\u7559\u53EF\u7528\u6642\u6578\uFF1A\u6642\u6578\u4E0D\u62CB\u8F49\u81F3 Payroll \u8A08\u7B97\u91D1\u984D\uFF0C\u4E14\u6B64\u6642\u6578\u4ECD\u53EF\u7E7C\u7E8C\u4F7F\u7528(\u82E5\u53EF\u7528\u6642\u9593\u5DF2\u5230\u671F\uFF0C\u9808\u4FEE\u6539\u671F\u9650\u65B9\u53EF\u7E7C\u7E8C\u4F7F\u7528)\u3002\n                ',
        type: 'content'
      }],
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_Transport',
        defaultMessage: '拋轉',
        type: '',
        prefix: '(3)'
      }, {
        id: 'SH_UseGuideL3Intro15',
        defaultMessage: '點擊「單項拋轉」後結算資料將移轉至 Payroll',
        type: 'content'
      }],
      isOpen: false,
      subMenu: []
    }]
  }, {
    label: 'SH_CreateReinstatementForm',
    title: '建立復職異動單',
    isOpen: false,
    prefix: '4.',
    subMenu: [{
      label: [{
        id: 'SH_UseGuideL2Intro',
        defaultMessage: '開始前，請您先確認並備妥以下資訊：',
        type: ''
      }, {
        id: 'SH_UseGuideL2Intro13',
        defaultMessage: '人員預計復職日',
        type: 'bulletPoint',
        prefix: ''
      }, {
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/foundation/PA_zh_tw'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_CreateEmployeeChangeForm',
        defaultMessage: 'People+ 建立異動單',
        type: '',
        prefix: ''
      }, {
        id: 'SH_UseGuideL3Intro18',
        defaultMessage: '將異動行為設為復職',
        type: 'content'
      }],
      isOpen: false,
      subMenu: []
    }]
  }, {
    label: 'PT_SetAttendanceRules',
    title: '設定人員出勤規範',
    isOpen: false,
    prefix: '5.',
    subMenu: [{
      label: [{
        id: 'SH_UseGuideL2Intro',
        defaultMessage: '開始前，請您先確認並備妥以下資訊：',
        type: ''
      }, {
        id: 'SH_UseGuideL2Intro03',
        defaultMessage: '人員適用班別、出勤規則及打卡規則',
        type: 'bulletPoint',
        prefix: ''
      }, {
        id: 'SH_UseGuideL2Intro04',
        defaultMessage: '人員特定之休假規則',
        type: 'bulletPoint',
        prefix: ''
      }, {
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/ta/manager/staffbasicinfo'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'PT_EmployeeInformation',
        defaultMessage: '人員基本資料',
        type: '',
        prefix: '(1)'
      }, {
        id: 'SH_UseGuideL3Intro04',
        defaultMessage: '於異動紀錄建立異動單，選定班別及出勤規則，並設定打卡規則',
        type: 'content'
      }],
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'PT_GenerateLeaveHours',
        defaultMessage: '產生假別時數',
        type: '',
        prefix: '(2)'
      }, {
        id: 'SH_UseGuideL3Intro05',
        defaultMessage: '假別時數依照出勤規則設定發放',
        type: 'content'
      }],
      isOpen: false,
      subMenu: []
    }]
  }, {
    label: 'SH_EmpInsuranceOperation',
    title: '人員加保作業',
    isOpen: false,
    prefix: '6.',
    subMenu: [{
      label: [{
        id: 'SH_UseGuideL2Intro',
        defaultMessage: '開始前，請您先確認並備妥以下資訊：',
        type: ''
      }, {
        id: 'SH_UseGuideL2Intro14',
        defaultMessage: '勞健保需加回之投保資訊',
        type: 'bulletPoint',
        prefix: ''
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_EmpInsuranceData',
        defaultMessage: '員工保險資料',
        type: ''
      }, {
        id: 'SH_UseGuideL3Intro19',
        defaultMessage: '選定人員後，於保險資料新增表單設定加保，並將設定生效日為復職日',
        type: 'content',
        prefix: ''
      }, {
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/payroll/masterdata/salary'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }]
  }]
}, {
  label: 'FD_AccountActivation',
  isOpen: false, // 添加 isOpen 状态以控制内层菜单的展开和收起
  title: '帳號啟用/忘記密碼',
  enable: true,
  subMenu: [{
    label: 'FD_AccountActivation',
    title: '帳號啟用',
    isOpen: false,
    prefix: '1.',
    subMenu: [{
      label: [{
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/foundation/setting/accountmanagement'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_SetEmployeeEmail',
        defaultMessage: '設定人員帳號 Email',
        type: '',
        prefix: '(1)'
      }, {
        id: 'SH_UseGuideL3Intro20',
        defaultMessage: '\n                 \u4F7F\u7528\u5DE5\u865F\u6216\u59D3\u540D\u627E\u5230\u8A72\u4EBA\u54E1\u5F8C\uFF0C\u5728\u300C\u7BA1\u7406\u529F\u80FD\u300D\u4E0B\u65B9\u7684\u7DE8\u8F2F\u5E33\u865F\u8655\uFF0C\u8F38\u5165 Email \u4F5C\u70BA\u767B\u5165\u5E33\u865F <br>\n                 \u2731 \u8ACB\u7559\u610F\uFF1A\u82E5\u641C\u5C0B\u4E0D\u5230\u8A72\u54E1\u5DE5\uFF0C\u8ACB\u78BA\u8A8D\u5176\u5E33\u865F\u662F\u5426\u5DF2\u9A57\u8B49\uFF0C\u4E26\u8ABF\u6574\u641C\u5C0B\u689D\u4EF6\u3002\n                ',
        type: 'content'
      }],
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_ReceiveAccountActivationEmail',
        defaultMessage: '收取帳號啟用信',
        type: '',
        prefix: '(2)'
      }, {
        id: 'SH_UseGuideL3Intro21',
        defaultMessage: '按啟用信內容指引，於 APP 或網頁版依序使用預設密碼登入、重設密碼、並進行身分驗證',
        type: 'content'
      }],
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_EditAccountEmail',
        defaultMessage: '修改帳號 Email',
        type: '',
        prefix: '(3)'
      }, {
        id: 'SH_UseGuideL3Intro22',
        defaultMessage: '若 Email 設定錯誤需修改，按照步驟(1)的 Email 設定方式即可完成 ',
        type: 'content'
      }],
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_BatchSetAccountEmail',
        defaultMessage: '批次設定帳號 Email',
        type: '',
        prefix: '(4)'
      }, {
        id: 'SH_UseGuideL3Intro23',
        defaultMessage: '將範本下載後，於 Excel 填妥人員對應 Email，上傳後即設定完成',
        type: 'content'
      }],
      isOpen: false,
      subMenu: []
    }]
  }, {
    label: 'AH_ForgetPassword',
    title: '忘記密碼',
    isOpen: false,
    prefix: '2.',
    subMenu: [{
      label: [{
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/foundation/setting/accountmanagement'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_ResetAccountPassword',
        defaultMessage: '重置帳號密碼',
        type: '',
        prefix: '(1)'
      }, {
        id: 'SH_UseGuideL3Intro24',
        defaultMessage: '\n                \u4F7F\u7528\u5DE5\u865F\u6216\u59D3\u540D\u627E\u5230\u8A72\u4EBA\u54E1\u5F8C\uFF0C\u9EDE\u9078\u300C\u7BA1\u7406\u529F\u80FD\u300D\u4E0B\u65B9\u7684\u91CD\u7F6E\u5BC6\u78BC<br>\n                \u2731 \u8ACB\u7559\u610F\uFF1A\u82E5\u641C\u5C0B\u4E0D\u5230\u8A72\u54E1\u5DE5\uFF0C\u8ACB\u78BA\u8A8D\u5176\u5E33\u865F\u662F\u5426\u5DF2\u9A57\u8B49\uFF0C\u4E26\u8ABF\u6574\u641C\u5C0B\u689D\u4EF6\u3002\n                ',
        type: 'content'
      }],
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_LoginAndResetPassword',
        defaultMessage: '登入並重設密碼',
        type: '',
        prefix: '(2)'
      }, {
        id: 'SH_UseGuideL3Intro25',
        defaultMessage: '使用系統給予的重置密碼登入後，按引導步驟依序重設密碼、重新登入、並完成身分驗證',
        type: 'content'
      }],
      isOpen: false,
      subMenu: []
    }]
  }]
}, {
  label: 'PT_SetUpTimetable',
  title: '排班',
  isOpen: false, // 添加 isOpen 状态以控制内层菜单的展开和收起
  enable: true,
  subMenu: [{
    label: 'SH_UseGuideL1Intro01',
    title: '確認班別設定',
    isOpen: false,
    prefix: '1.',
    subMenu: [{
      label: [{
        id: 'SH_UseGuideL2Intro',
        defaultMessage: '開始前，請您先確認並備妥以下資訊：',
        type: ''
      }, {
        id: 'SH_UseGuideL2Intro15',
        defaultMessage: '欲排班的班別',
        type: 'bulletPoint',
        prefix: ''
      }, {
        id: 'SH_UseGuideL2Intro16',
        defaultMessage: '該班別的行事曆設定',
        type: 'bulletPoint',
        prefix: ''
      }, {
        id: 'SH_UseGuideL2Intro17',
        defaultMessage: '欲使用的出勤規則',
        type: 'bulletPoint',
        prefix: ''
      }, {
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/ta/manager/modulesetting/parameter/shifts'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro26',
        defaultMessage: '確認班別使用的行事曆',
        type: '',
        prefix: '(1)'
      }, {
        id: 'SH_UseGuideL3Intro27',
        defaultMessage: '至班別列表確認欲排班別使用的行事曆為何',
        type: 'content'
      }, {
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/ta/manager/modulesetting/parameter/shifts'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro28',
        defaultMessage: '檢查該行事曆',
        type: '',
        prefix: '(2)'
      }, {
        id: 'SH_UseGuideL3Intro29',
        defaultMessage: '排班用之行事曆設定無須建立休假事件（如國定假日、例休假），應依班表安排',
        type: 'content'
      }, {
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/ta/manager/modulesetting/parameter/calendarmanage'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro30',
        defaultMessage: '開啟出勤規則中的排班功能',
        type: '',
        prefix: '(3)'
      }, {
        id: 'SH_UseGuideL3Intro31',
        defaultMessage: '至該出勤規則內的「排班規則」分頁將右上角排班功能打開',
        type: 'content'
      }, {
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/ta/manager/modulesetting/parameter/attendance'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro32',
        defaultMessage: '確認出勤規則的排班「月休設定」',
        type: '',
        prefix: '(4)'
      }, {
        id: 'SH_UseGuideL3Intro33',
        defaultMessage: '確認年度月份的可排休天數，月休為每月員工應休的假，有效期限建議保留一個月，當月結清較優',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }]
  }, {
    label: 'SH_UseGuideL1Intro02',
    title: '人員套用班別與出勤規則',
    isOpen: false,
    prefix: '2.',
    subMenu: [{
      label: [{
        id: 'SH_UseGuideL2Intro',
        defaultMessage: '開始前，請您先確認並備妥以下資訊：',
        type: ''
      }, {
        id: 'SH_UseGuideL2Intro18',
        defaultMessage: '欲排班人員',
        type: 'bulletPoint',
        prefix: ''
      }, {
        id: 'SH_UseGuideL2Intro19',
        defaultMessage: '人員適用班別',
        type: 'bulletPoint',
        prefix: ''
      }, {
        id: 'SH_UseGuideL2Intro20',
        defaultMessage: '人員適用出勤規則',
        type: 'bulletPoint',
        prefix: ''
      }, {
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/ta/manager/staffbasicinfo'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro34',
        defaultMessage: '確認人員已套用之班別及出勤規則',
        type: '',
        prefix: ''
      }, {
        id: 'SH_UseGuideL3Intro35',
        defaultMessage: '若需調整班別或出勤規則，於異動紀錄新增一筆資料調整',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }]
  }, {
    label: 'SH_UseGuideL1Intro03',
    title: '介面操作排班',
    isOpen: false,
    prefix: '3.',
    subMenu: [{
      label: [{
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/ta/supervisor/shiftscheduleapprovelist'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro36',
        defaultMessage: '搜尋單位及年度/月份的班表',
        type: '',
        prefix: '(1)'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro37',
        defaultMessage: '點擊「編輯」開始排班',
        type: '',
        prefix: '(2)'
      }, {
        id: 'SH_UseGuideL3Intro38',
        defaultMessage: '\n                \u9EDE\u64CA\u7070\u6846\u4E2D\u300C\u4F11\u5047\u9078\u64C7/\u73ED\u6B21\u9078\u64C7\u300D\u9078\u9805\u5F8C\uFF0C\u4F9D\u570B\u5B9A\u5047\u65E5 > \u4F8B\u5047\u65E5 > \u4F11\u606F\u65E5 > \u73ED\u6B21\u7684\u9806\u5E8F\uFF0C\u5728\u4EBA\u54E1\u3001\u65E5\u671F\u5C0D\u61C9\u7684\u8868\u683C\u70BA\u4EBA\u54E1\u6392\u73ED\u3002\n                \u5982\u6B32\u8ABF\u6574\u5DF2\u6392\u5167\u5BB9\uFF0C\u53EF\u5728\u8A72\u8868\u683C\u5167\u7684\u73ED\u6B21\u7B26\u865F\u6309\u53F3\u9375\uFF0C\u9EDE\u64CA\u300C\u522A\u9664\u300D\u6216\u300C\u81EA\u8A02\u73ED\u6B21\u6642\u9593\u300D\u8ABF\u6574\n                ',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro39',
        defaultMessage: '檢查已排班時數、已排休天數',
        type: '',
        prefix: '(3)'
      }, {
        id: 'SH_UseGuideL3Intro40',
        defaultMessage: '點擊「統計資訊」可查看人員個別排班時數及排休天數',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro41',
        defaultMessage: '完成排班後，點擊檢查並發布',
        type: '',
        prefix: '(4)'
      }, {
        id: 'SH_UseGuideL3Intro42',
        defaultMessage: '系統將檢查人員是否符合工時設定規則，您可依需求調整班表或直接發佈',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }]
  }, {
    label: 'SH_UseGuideL1Intro04',
    title: 'Excel 匯入排班',
    isOpen: false,
    prefix: '4.',
    subMenu: [{
      label: [{
        id: 'SH_UseGuideL2Intro',
        defaultMessage: '開始前，請您先確認並備妥以下資訊：',
        type: ''
      }, {
        id: 'SH_UseGuideL2Intro21',
        defaultMessage: '欲排班人員工號',
        type: 'bulletPoint',
        prefix: ''
      }, {
        id: 'SH_UseGuideL2Intro22',
        defaultMessage: '日期對應之工作事件(例：上班/例休假/月休-國定假日)',
        type: 'bulletPoint',
        prefix: ''
      }, {
        id: 'SH_UseGuideL2Intro23',
        defaultMessage: '欲排入之班次',
        type: 'bulletPoint',
        prefix: ''
      }, {
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/ta'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro43',
        defaultMessage: '下載班表匯入 Excel 範本',
        type: '',
        prefix: '(1)'
      }, {
        id: 'SH_UseGuideL3Intro44',
        defaultMessage: '至 Attendence 模組點擊「班表匯入」後，點擊視窗右上角「下載範本」',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro45',
        defaultMessage: '填妥班表匯入 Excel 欄位',
        type: '',
        prefix: '(2)'
      }, {
        id: 'SH_UseGuideL3Intro46',
        defaultMessage: '將 Excel 範本中*符號的欄位依序填妥，「狀態代碼」、「班次代碼」可參考範本中對應的分頁輔助填寫',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro47',
        defaultMessage: '回到 Apollo XE 將班表匯入處選擇檔案',
        type: '',
        prefix: '(3)'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro48',
        defaultMessage: '產生資料後，檢查資料再上傳',
        type: '',
        prefix: '(4)'
      }, {
        id: 'SH_UseGuideL3Intro49',
        defaultMessage: '如發生錯誤，請依序系統訊息調整上傳檔案的內容',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }]
  }]
}, {
  label: 'PT_OvertimeApplication',
  title: '加班申請',
  isOpen: false, // 添加 isOpen 状态以控制内层菜单的展开和收起
  enable: true,
  subMenu: [{
    label: 'SH_UseGuideL1Intro05',
    title: '員工申請加班',
    isOpen: false,
    prefix: '1.',
    subMenu: [{
      label: [{
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/ta/personal/OvertimeRequestFormPage'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro51',
        defaultMessage: '依序填寫加班時間、給付方式及加班事由，並留意公司之加班規則',
        type: '',
        prefix: ''
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }]
  }, {
    label: 'SH_UseGuideL1Intro06',
    title: '主管審核加班單',
    isOpen: false,
    prefix: '2.',
    subMenu: [{
      label: [{
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/ta/personal/approvementlist'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro52',
        defaultMessage: '點擊整列資料可檢視加班單明細',
        type: '',
        prefix: '(1)'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro53',
        defaultMessage: '比對人員打卡記錄',
        type: '',
        prefix: '(2)'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro54',
        defaultMessage: '選擇審核結果後按「確認」送出',
        type: '',
        prefix: '(3)'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }]
  }, {
    label: 'SH_UseGuideL1Intro07',
    title: '員工確認（公司不允許事後申請加班者，需經此步驟）',
    isOpen: false,
    prefix: '3.',
    subMenu: [{
      label: [{
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/ta/personal/FormApplyRecord/overtimerecords'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro55',
        defaultMessage: '點擊狀態為「待確認」的整列加班資料',
        type: '',
        prefix: '(1)'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro56',
        defaultMessage: '調整實際加班日期/時間',
        type: '',
        prefix: '(2)'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro57',
        defaultMessage: '填寫完畢後按「確認」送出',
        type: '',
        prefix: '(3)'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }]
  }]
}, {
  label: 'PT_RequestSpecialLeaveForm',
  title: '申請特殊假別',
  isOpen: false, // 添加 isOpen 状态以控制内层菜单的展开和收起
  enable: true,
  subMenu: [{
    label: 'SH_UseGuideL1Intro08',
    title: '提出特殊假別申請並請假',
    isOpen: false,
    prefix: '1.',
    subMenu: [{
      label: [{
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/ta/personal/AskForLeavePage'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro58',
        defaultMessage: '選擇欲申請的假別',
        type: '',
        prefix: '(1)'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro59',
        defaultMessage: '取得特殊假別',
        type: '',
        prefix: '(2)'
      }, {
        id: 'SH_UseGuideL3Intro60',
        defaultMessage: '\n                \u82E5\u5728\u5047\u5225\u9078\u55AE\u627E\u4E0D\u5230\u6B32\u7533\u8ACB\u7684\u5047\u5225\uFF0C\u8ACB\u9EDE\u9078\u756B\u9762\u53F3\u5074\u7684\u300C\u7279\u6B8A\u5047\u5225\u7533\u8ACB\u300D\u958B\u555F\u7533\u8ACB\u8996\u7A97\uFF0C\u586B\u5BEB\u9001\u51FA\u5F8C\uFF0C\u5373\u53EF\u53D6\u5F97\u8A72\u5047\u5225\u7684\u6642\u6578\uFF0C\u4E26\u5B8C\u6210\u8ACB\u5047\u6D41\u7A0B\u3002<br>\n                \u2731 \u8ACB\u7559\u610F\uFF1A\u4EBA\u54E1\u96D6\u53EF\u5B8C\u6210\u8ACB\u5047\u6D41\u7A0B\uFF0C\u5176\u7533\u8ACB\u4E4B\u7279\u6B8A\u5047\u5225\u6642\u6578\u9700\u7D93\u7BA1\u7406\u8005\u5BE9\u6838\u3002\n                ',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }]
  }, {
    label: 'SH_UseGuideL1Intro09',
    title: '主管審核請假單',
    isOpen: false,
    prefix: '2.',
    subMenu: [{
      label: [{
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/ta/personal/approvementlist'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro61',
        defaultMessage: '點擊整列申請單可進入審核視窗',
        type: '',
        prefix: '(1)'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro62',
        defaultMessage: '給予審核結果及意見',
        type: '',
        prefix: '(2)'
      }, {
        id: 'SH_UseGuideL3Intro63',
        defaultMessage: '選擇同意或不同意後，按下「確認」送出',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }]
  }, {
    label: 'SH_UseGuideL1Intro10',
    title: '管理者(HR)審核特殊假別申請',
    isOpen: false,
    prefix: '3.',
    subMenu: [{
      label: [{
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/ta/manager/LeaveTypeManage/specialleaves'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro61',
        defaultMessage: '點擊整列申請單可進入審核視窗',
        type: '',
        prefix: '(1)'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro62',
        defaultMessage: '給予審核結果及意見',
        type: '',
        prefix: '(2)'
      }, {
        id: 'SH_UseGuideL3Intro64',
        defaultMessage: '\n                \u9078\u64C7\u540C\u610F\u6216\u4E0D\u540C\u610F\u5F8C\uFF0C\u6309\u4E0B\u300C\u78BA\u8A8D\u300D\u9001\u51FA <br>\n                \u2731 \u8ACB\u7559\u610F\uFF1A\u82E5\u9023\u52D5\u6B64\u7533\u8ACB\u55AE\u7684\u8ACB\u5047\u55AE\u5DF2\u88AB\u6838\u51C6\uFF0C\u60A8\u9700\u5148\u81F3<a href=\'/ta/manager/formrecordmanage/leaverecords\'>\u8868\u55AE\u7D00\u9304\u7BA1\u7406(/ta/manager/formrecordmanage/leaverecords)</a>\u4FEE\u6539\u8ACB\u5047\u55AE\u8CC7\u8A0A \n                ',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }]
  }]
}, {
  label: 'PT_ImportLeaveTypeFlow',
  title: '匯入假別流程及調整',
  isOpen: false, // 添加 isOpen 状态以控制内层菜单的展开和收起
  enable: true,
  subMenu: [{
    label: 'SH_UseGuideL1Intro11',
    title: '建立假別並開啟',
    isOpen: false,
    prefix: '1.',
    subMenu: [{
      label: [{
        id: 'SH_UseGuideL2Intro',
        defaultMessage: '開始前，請您先確認並備妥以下資訊：',
        type: ''
      }, {
        id: 'SH_UseGuideL2Intro24',
        defaultMessage: '欲新增、調整的假別',
        type: 'bulletPoint',
        prefix: ''
      }, {
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/ta/manager/modulesetting/parameter/leavetypesname'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro65',
        defaultMessage: '新增公司自訂假別',
        type: '',
        prefix: '(1)'
      }, {
        id: 'SH_UseGuideL3Intro66',
        defaultMessage: '點擊右上角新增後，填入假別的代碼及名稱',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro67',
        defaultMessage: '確認該假別的設定為開啟',
        type: '',
        prefix: '(2)'
      }, {
        id: 'SH_UseGuideL3Intro68',
        defaultMessage: '新增假別後，回到列表頁檢查該假別的設定為開啟 ',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }]
  }, {
    label: 'SH_UseGuideL1Intro12',
    title: '確認出勤規則中假別設定',
    isOpen: false,
    prefix: '2.',
    subMenu: [{
      label: [{
        id: 'SH_UseGuideL2Intro',
        defaultMessage: '開始前，請您先確認並備妥以下資訊：',
        type: ''
      }, {
        id: 'SH_UseGuideL2Intro25',
        defaultMessage: '欲套用此假別的人員的出勤規則 ',
        type: 'bulletPoint',
        prefix: ''
      }, {
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/ta/manager/modulesetting/parameter/attendance'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro69',
        defaultMessage: '設定出勤規則',
        type: '',
        prefix: '(1)'
      }, {
        id: 'SH_UseGuideL3Intro70',
        defaultMessage: '選定要修改的出勤規則後，進入設定頁',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro71',
        defaultMessage: '確認假別規則設定',
        type: '',
        prefix: '(2)'
      }, {
        id: 'SH_UseGuideL3Intro72',
        defaultMessage: '在「假別規則」分頁中，找到需調整的假別後進入其設定頁，請逐一檢查給假設定、請假設定、薪資設定後，按下「確認」以儲存設定',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro73',
        defaultMessage: '確認假別在出勤規則中已開啟',
        type: '',
        prefix: '(3)'
      }, {
        id: 'SH_UseGuideL3Intro74',
        defaultMessage: '開啟後，套用此出勤規則的員工便能申請此特殊假別',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }]
  }, {
    label: 'SH_UseGuideL1Intro13',
    title: '匯入員工可用時數',
    isOpen: false,
    prefix: '3.',
    subMenu: [{
      label: [{
        id: 'SH_UseGuideL2Intro',
        defaultMessage: '開始前，請您先確認並備妥以下資訊：',
        type: ''
      }, {
        id: 'SH_UseGuideL2Intro26',
        defaultMessage: '欲給假人員名單',
        type: 'bulletPoint',
        prefix: ''
      }, {
        id: 'SH_UseGuideL2Intro27',
        defaultMessage: '欲給假別及使用時數、期限',
        type: 'bulletPoint',
        prefix: ''
      }, {
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/ta/manager/LeaveTypeManage/LeaveMaintain'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro75',
        defaultMessage: '選定欲匯入的年度及假別',
        type: '',
        prefix: '(1)'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro76',
        defaultMessage: '依據匯入範本填入資料',
        type: '',
        prefix: '(2)'
      }, {
        id: 'SH_UseGuideL3Intro77',
        defaultMessage: '於 Excel 填入要套用此假別的人員工號或姓名、可用時數(時、分)、有效開始時間、有效結束時間、計薪基準日',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro78',
        defaultMessage: '上傳 Excel 檔案並產生資料',
        type: '',
        prefix: '(3)'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro79',
        defaultMessage: '調整已給假別時數',
        type: '',
        prefix: '(4)'
      }, {
        id: 'SH_UseGuideL3Intro80',
        defaultMessage: '您可在此頁面使用「假別」、「工號/姓名」來搜尋指定資料後，點擊「設定」功能管理個別人員特定假別的可用時數、有效期間及計薪基準日',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }]
  }]
}, {
  label: 'SH_AttendanceConclusion',
  title: '出勤結算/薪資計算',
  isOpen: false, // 添加 isOpen 状态以控制内层菜单的展开和收起
  enable: true,
  subMenu: [{
    label: 'SH_UseGuideL1Intro14',
    title: '出勤紀錄及簽核中表單確認',
    isOpen: false,
    prefix: '1.',
    subMenu: [{
      label: [{
        id: 'SH_UseGuideL2Intro',
        defaultMessage: '開始前，請您先確認並備妥以下資訊：',
        type: ''
      }, {
        id: 'SH_UseGuideL2Intro28',
        defaultMessage: '欲結算的日期區間',
        type: 'bulletPoint',
        prefix: ''
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro81',
        defaultMessage: '確認打卡記錄維護無異常',
        type: '',
        prefix: '(1)'
      }, {
        id: 'SH_UseGuideL3Intro121',
        defaultMessage: '選定欲結算的時間區間後，將異常打卡記錄全數結清，確認人員的異常紀錄為曠職、需補登打卡或請假',
        type: 'content'
      }, {
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/ta/manager/checkin/checkinrecords/oddrecords'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro82',
        defaultMessage: '確認簽核中表單皆簽完',
        type: '',
        prefix: '(2)'
      }, {
        id: 'SH_UseGuideL3Intro122',
        defaultMessage: '選定欲結算的時間區間後，將未完成簽核的表單全數結清，確認表單應催簽、變更簽核人、代理簽核、或刪除 ',
        type: 'content'
      }, {
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/ta/manager/formrecordmanage/approvingformrecords'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }]
  }, {
    label: 'SH_UseGuideL1Intro15',
    title: '離職(留停)結算',
    isOpen: false,
    prefix: '2.',
    subMenu: [{
      label: [{
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/ta/manager/billing/resign'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_CreateLeaveWithoutPaySettlement',
        defaultMessage: '新增留停結算並產生資料',
        type: '',
        prefix: '(1)'
      }, {
        id: 'SH_UseGuideL3Intro12',
        defaultMessage: '建議將結算年度回推數年，以利檢查過往未結算之代金',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro13',
        defaultMessage: '檢查「設定」內各分頁的資料',
        type: '',
        prefix: '(2)'
      }, {
        id: 'SH_UseGuideL3Intro14',
        defaultMessage: '\n                \u8ACB\u5206\u5225\u6AA2\u67E5\u51FA\u52E4\u7570\u5E38\u3001\u73ED\u8868\u7D50\u7B97\u3001\u8ACB\u5047\u6263\u6B3E\u3001\u52A0\u73ED\u8CBB\u3001\u88DC\u4F11\u4EE3\u91D1\u3001\u4E0D\u4F11\u5047\u4EE3\u91D1\u51715\u500B\u5206\u9801<br>\n                \u2731 \u9078\u9805\u8AAA\u660E\uFF1A<br>\n                - \u7D50\u7B97\u62CB\u8F49\uFF1A\u6642\u6578\u5C07\u62CB\u8F49\u81F3 Payroll \u8A08\u7B97\u91D1\u984D\u3002<br>\n                - \u7D50\u7B97\u4E0D\u62CB\u8F49\uFF1A\u6642\u6578\u4E0D\u62CB\u8F49\u81F3 Payroll \u8A08\u7B97\u91D1\u984D\uFF0C\u4E14\u6B64\u6642\u6578\u4EA6\u9396\u5B9A\u4E0D\u53EF\u518D\u4F7F\u7528\u3002<br>\n                - \u4FDD\u7559\u53EF\u7528\u6642\u6578\uFF1A\u6642\u6578\u4E0D\u62CB\u8F49\u81F3 Payroll \u8A08\u7B97\u91D1\u984D\uFF0C\u4E14\u6B64\u6642\u6578\u4ECD\u53EF\u7E7C\u7E8C\u4F7F\u7528(\u82E5\u53EF\u7528\u6642\u9593\u5DF2\u5230\u671F\uFF0C\u9808\u4FEE\u6539\u671F\u9650\u65B9\u53EF\u7E7C\u7E8C\u4F7F\u7528)\u3002 \n                ',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_Transport',
        defaultMessage: '拋轉',
        type: '',
        prefix: '(3)'
      }, {
        id: 'SH_UseGuideL3Intro15',
        defaultMessage: '點擊「單項拋轉」後結算資料將移轉至 Payroll',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }]
  }, {
    label: 'SH_UseGuideL1Intro16',
    title: '一般結算',
    isOpen: false,
    prefix: '3.',
    subMenu: [{
      label: [{
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/ta/manager/billing/common'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro83',
        defaultMessage: '依序計算各資料類型',
        type: '',
        prefix: '(1)'
      }, {
        id: 'SH_UseGuideL3Intro84',
        defaultMessage: '按薪資年月搜尋資料後，從「出勤異常」資料開始、至「其他假別代金」，由上至下一一在「設定」處點擊計算功能。若系統產生的資料無誤，則點擊「取消」或右上角 x 離開視窗；若有異常資料，請將資料作廢後，先至表單紀錄管理調整資料後，再行重新計算。 ',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro85',
        defaultMessage: '未簽核完畢的加班單將無法結算',
        type: '',
        prefix: '(2)'
      }, {
        id: 'SH_UseGuideL3Intro86',
        defaultMessage: '加班若遇「有加班時數、無加班費」的狀況，為加班單尚未簽核完畢造成，需先作廢此結算結果，並回到表單紀錄管理將加班單確認簽核完畢，再行重新計算。',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro87',
        defaultMessage: '作廢結算資料',
        type: '',
        prefix: '(3)'
      }, {
        id: 'SH_UseGuideL3Intro88',
        defaultMessage: '如需作廢已結算的資料，請由「其他假別代金」資料類型，由下往上一一作廢。',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_Transport',
        defaultMessage: '拋轉',
        type: '',
        prefix: '(4)'
      }, {
        id: 'SH_UseGuideL3Intro89',
        defaultMessage: '\n                \u9078\u64C7\u5404\u8CC7\u6599\u985E\u578B\u53F3\u5074\u7684\u300C\u55AE\u9805\u62CB\u8F49\u300D\u5C07\u9010\u500B\u8CC7\u6599\u985E\u578B\u62CB\u81F3 Payroll \u8A08\u7B97\u91D1\u984D\uFF0C\u6216\u9EDE\u64CA\u5168\u6578\u62CB\u8F49\u6574\u6279\u8655\u7406\u3002 <br>\n                \u2731 \u8ACB\u7559\u610F\uFF1A\u7D50\u7B97\u72C0\u614B\u6210\u70BA\u300C\u5DF2\u7D50\u7B97\u300D\u5F8C\uFF0C\u8A72\u5340\u9593\u7684\u51FA\u52E4\u8CC7\u6599\u4FBF\u7121\u6CD5\u8B8A\u66F4\uFF1B\u5982\u6B32\u8ABF\u6574\uFF0C\u8ACB\u5148\u5C07\u5DF2\u7D50\u7B97\u7684\u8CC7\u6599\u4F5C\u5EE2\uFF0C\u4E26\u65BC\u4FEE\u6539\u51FA\u52E4\u8CC7\u6599\u5F8C\u91CD\u65B0\u62CB\u8F49\u3002\n                ',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }]
  }, {
    label: 'SH_UseGuideL1Intro17',
    title: '核對保費',
    isOpen: false,
    prefix: '4.',
    subMenu: [{
      label: [{
        id: 'SH_UseGuideL2Intro',
        defaultMessage: '開始前，請您先確認並備妥以下資訊：',
        type: ''
      }, {
        id: 'SH_UseGuideL2Intro29',
        defaultMessage: '勞保/勞退/健保當期帳單',
        type: 'bulletPoint',
        prefix: ''
      }, {
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/payroll/application/checkpremium'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro90',
        defaultMessage: '分別上傳勞健保帳單',
        type: '',
        prefix: '(1)'
      }, {
        id: 'SH_UseGuideL3Intro91',
        defaultMessage: '選定年度及投保單位後，點擊「新增項目」進入核對保費畫面，於該視窗選擇對保項目、上傳帳單後，點擊「開始核對」後，系統將帶出核對結果。',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro92',
        defaultMessage: '針對核對結果修正',
        type: '',
        prefix: '(2)'
      }, {
        id: 'SH_UseGuideL3Intro93',
        defaultMessage: '\n                \u9EDE\u64CA\u5DE6\u4E0A\u89D2\u300C\u5DEE\u984D\u8CC7\u6599\u300D\u53EF\u4E0B\u8F09\u6838\u5C0D\u7D50\u679C\uFF0C\u78BA\u8A8D\u6BCF\u7B46\u8CC7\u6599\u5167\u5BB9\u53CA\u5DEE\u984D\u3002\u82E5\u6838\u5C0D\u7D50\u679C\u7121\u8AA4\uFF0C\u4FBF\u53EF\u76F4\u63A5\u532F\u5165\uFF1B\u6709\u5DEE\u984D\u600E\u8FA6(?)<br>\n                \uFF0A\u8ACB\u7559\u610F\uFF1A\u82E5\u6309\u4E0B\u300C\u78BA\u5B9A\u532F\u5165\u300D\u6642\u4ECD\u6709\u5DEE\u984D\uFF0C\u8A72\u91D1\u984D\u5C07\u76F4\u63A5\u8A08\u5165\u8A08\u85AA\u3001\u7121\u6CD5\u8FD4\u56DE\uFF0C\u8ACB\u78BA\u8A8D\u6838\u5C0D\u7121\u8AA4\u518D\u884C\u532F\u5165\u3002\n                ',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }]
  }, {
    label: 'SH_UseGuideL1Intro18',
    title: '執行薪資/獎金作業',
    isOpen: false,
    prefix: '5.',
    subMenu: [{
      label: [{
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/payroll/operation/calculate'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro93',
        defaultMessage: '選定開帳年月',
        type: '',
        prefix: '(1)'
      }, {
        id: 'SH_UseGuideL3Intro94',
        defaultMessage: '選擇要執行薪資/獎金作業的年、月份後，進行開帳。',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro95',
        defaultMessage: '資料確認',
        type: '',
        prefix: '(2)'
      }, {
        id: 'SH_UseGuideL3Intro96',
        defaultMessage: '\n                \u5206\u5225\u78BA\u8A8D\u4E03\u9805\u8CC7\u6599\u7684\u6B63\u78BA\u6027\uFF1A<br>\n                - \u4EBA\u54E1\u8CC7\u6599\uFF1A\u7576\u6708\u65B0\u9032/\u96E2\u8077/\u7559\u8077/\u5FA9\u8077\u7684\u540D\u55AE\uFF0C\u662F\u5426\u6B63\u78BA\uFF1B\u7D0D\u5165\u6B64\u85AA\u8CC7\u7BC4\u570D\u7684\u4EBA\u54E1\u540D\u55AE\u662F\u5426\u6B63\u78BA\u3002<br>\n                - \u85AA\u8CC7\u8CC7\u6599\uFF1A\u4EBA\u54E1\u7684\u85AA\u8CC7\u7D50\u69CB(\u5167\u5BB9)\u662F\u5426\u6B63\u78BA\u3002<br>\n                - \u4FDD\u96AA\u8CC7\u6599\uFF1A\u4EBA\u54E1\u7684\u52DE\u4FDD\u3001\u5065\u4FDD\u3001\u52DE\u9000\u91D1\u984D\u662F\u5426\u6B63\u78BA\u3002<br>\n                - \u51FA\u52E4\u8CC7\u6599\uFF1A\u5F9EAttendance\u62CB\u8F49\u800C\u4F86\u7684\u51FA\u52E4\u8CC7\u6599\u662F\u5426\u6B63\u78BA\u3002<br>\n                - \u6838\u5C0D\u4FDD\u8CBB\u5DEE\u984D\uFF1A\u4EBA\u54E1\u4E0A\u500B\u6708\u7684\u52DE\u4FDD\u3001\u5065\u4FDD\u3001\u52DE\u4FDD\u7684\u6838\u5C0D\u4FDD\u8CBB\u7684\u5DEE\u984D\u662F\u5426\u6B63\u78BA\u3002<br>\n                - \u5176\u4ED6\u52A0\u6263\u9805\uFF1A\u9700\u8981\u53E6\u884C\u5E6B\u540C\u4EC1\u52A0\u6263\u7684\u8CBB\u7528\u65BC\u6B64\u8655\u8F38\u5165\u6216\u532F\u5165\uFF0C\u82E5\u734E\u91D1\u8981\u5408\u4F75\u7576\u6708\u85AA\u8CC7\u8A08\u7B97\uFF0C\u8ACB\u65BC\u6B64\u8655\u9375\u5165\u91D1\u984D\u3002\n                ',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro97',
        defaultMessage: '資料計算',
        type: '',
        prefix: '(3)'
      }, {
        id: 'SH_UseGuideL3Intro98',
        defaultMessage: '點擊「計算」後，等待約30分鐘後重新整理畫面，即可下載並檢視各項明細。建議您在核對薪資科目金額、確認無誤後再行關帳。',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro99',
        defaultMessage: '計算完成',
        type: '',
        prefix: '(4)'
      }, {
        id: 'SH_UseGuideL3Intro100',
        defaultMessage: '請設定薪資通知，同仁才能在公告時間後，查看個人薪資單。',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro101',
        defaultMessage: '獎金作業',
        type: '',
        prefix: '(5)'
      }, {
        id: 'SH_UseGuideL3Intro102',
        defaultMessage: '若獎金要與薪資分開發放，請選擇右上角「新增獎金作業」，並執行上述步驟(2)至(4)。',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }]
  }]
}, {
  label: 'SH_AnnualOperation',
  title: '年度作業',
  isOpen: false, // 添加 isOpen 状态以控制内层菜单的展开和收起
  enable: true,
  subMenu: [{
    label: 'SH_UseGuideL1Intro19',
    title: '工號前置碼設定',
    isOpen: false,
    prefix: '1.',
    subMenu: [{
      label: [{
        id: 'SH_UseGuideL2Intro',
        defaultMessage: '開始前，請您先確認並備妥以下資訊：',
        type: ''
      }, {
        id: 'SH_UseGuideL2Intro31',
        defaultMessage: '僅以年度作為工號前置碼的公司需進行此作業 ',
        type: 'bulletPoint',
        prefix: ''
      }, {
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/Foundation/FormParameter_zh_tw'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro103',
        defaultMessage: '新增參數選項',
        type: '',
        prefix: ''
      }, {
        id: 'SH_UseGuideL3Intro104',
        defaultMessage: '找到「工號」欄位後，點擊設定下方的「選項設定」，點擊視窗右上方的「新增項目」後，新增新年度的代碼。',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }]
  }, {
    label: 'SH_UseGuideL1Intro20',
    title: '發布年度行事曆',
    isOpen: false,
    prefix: '2.',
    subMenu: [{
      label: [{
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/ta/manager/modulesetting/parameter/calendarmanage'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro105',
        defaultMessage: '常日班行事曆',
        type: '',
        prefix: '(1)'
      }, {
        id: 'SH_UseGuideL3Intro106',
        defaultMessage: '系統每年會依據政府行政機關辦公日曆產生「範本行事曆」，可直接點擊右上方「套用範本」帶入。此行事曆會呈現當年度國定假日、休息日（彈性放假）、特殊上班日（補班）。',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro107',
        defaultMessage: '排班制行事曆',
        type: '',
        prefix: '(2)'
      }, {
        id: 'SH_UseGuideL3Intro108',
        defaultMessage: '直接新增「空白行事曆」即可使用。',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro109',
        defaultMessage: '公司特定之特殊事件',
        type: '',
        prefix: '(3)'
      }, {
        id: 'SH_UseGuideL3Intro110',
        defaultMessage: '點擊右上方「新增事件」以建立公司特定的特殊上班日、休息日或例假日。 ',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro111',
        defaultMessage: '發布行事曆',
        type: '',
        prefix: '(4)'
      }, {
        id: 'SH_UseGuideL3Intro112',
        defaultMessage: '在發布後，此行事曆之對應事件才會套用至人員班表中。 ',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }]
  }, {
    label: 'SH_UseGuideL1Intro21',
    title: '年度給假',
    isOpen: false,
    prefix: '3.',
    subMenu: [{
      label: [{
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/ta/manager/LeaveTypeManage/LeaveMaintain'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro113',
        defaultMessage: '產生明年度假別時數',
        type: '',
        prefix: ''
      }, {
        id: 'SH_UseGuideL3Intro114',
        defaultMessage: '點擊右上方「產生假別時數」按鈕，針對單一假別批次產生，或點擊視窗中「全數產生」按鈕一次產生全假別。',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }]
  }, {
    label: 'SH_UseGuideL1Intro22',
    title: '設定排班人員月休',
    isOpen: false,
    prefix: '4.',
    subMenu: [{
      label: [{
        id: 'SH_UseGuideL2Intro',
        defaultMessage: '開始前，請您先確認並備妥以下資訊：',
        type: ''
      }, {
        id: 'SH_UseGuideL2Intro20',
        defaultMessage: '人員適用出勤規則',
        type: 'bulletPoint',
        prefix: ''
      }, {
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/ta/manager/modulesetting/parameter/attendance'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro115',
        defaultMessage: '進入排班人員使用之出勤規則設定',
        type: '',
        prefix: '(1)'
      }, {
        id: 'SH_UseGuideL3Intro70',
        defaultMessage: '選定要修改的出勤規則後，進入設定頁',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro116',
        defaultMessage: '「排班規則」分頁設定月休',
        type: '',
        prefix: '(2)'
      }, {
        id: 'SH_UseGuideL3Intro117',
        defaultMessage: '\n                \u9032\u5165\u6708\u4F11\u8A2D\u5B9A\u5F48\u7A97\u5F8C\uFF0C\u5C07\u5E74\u5EA6\u5207\u63DB\u81F3\u9694\u5E74\uFF0C\u8ACB\u586B\u5BEB\u4E26\u78BA\u8A8D\u5E74\u5EA6\u6708\u4EFD\u7684\u53EF\u6392\u4F11\u5929\u6578\u3001\u4F11\u5047\u65E5\u6578\u7B49\u8CC7\u8A0A\uFF0C\u9EDE\u64CA\u300C\u78BA\u8A8D\u300D\u5F8C\uFF0C\u9069\u7528\u6B64\u51FA\u52E4\u898F\u5247\u7684\u4EBA\u54E1\u5373\u53EF\u65BC\u9694\u5E74\u5957\u7528\u6392\u4F11\u5929\u6578\u3002 \n                ',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }]
  }, {
    label: 'SH_UseGuideL1Intro23',
    title: '計薪週期維護',
    isOpen: false,
    prefix: '5.',
    subMenu: [{
      label: [{
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/payroll/setting/parameters/salaryperiod'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro118',
        defaultMessage: '為薪資範圍產生隔年度計薪週期',
        type: '',
        prefix: ''
      }, {
        id: 'SH_UseGuideL3Intro119',
        defaultMessage: '選定薪資範圍、並將年度選擇為隔年後，點擊右側「產生計薪週期」按鈕，下方列表即可看見明年度各月計薪週期資訊。',
        type: 'content'
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }]
  }, {
    label: 'SH_UseGuideL1Intro24',
    title: '職災費率調整',
    isOpen: false,
    prefix: '6.',
    subMenu: [{
      label: [{
        id: 'SH_UseGuideL2Intro',
        defaultMessage: '開始前，請您先確認並備妥以下資訊：',
        type: ''
      }, {
        id: 'SH_UseGuideL2Intro32',
        defaultMessage: '所屬行業別之職災費率 ',
        type: 'bulletPoint',
        prefix: ''
      }, {
        id: 'SH_GetStarted',
        defaultMessage: '開始操作',
        type: 'url',
        link: '/payroll/setting/parameters/insuranceapplicantunit'
      }],
      type: 'url',
      isOpen: false,
      subMenu: []
    }, {
      label: [{
        id: 'SH_UseGuideL3Intro120',
        defaultMessage: '依據投保單位所屬行業別，逐一設定對應職災費率。',
        type: '',
        prefix: ''
      }],
      type: '',
      isOpen: false,
      subMenu: []
    }]
  }]
}];


/*****************
 ** WEBPACK FOOTER
 ** ./~/@mayo/xe-ui-kit/lib/components/SideMenu/components/MainContent/data.js
 ** module id = 2017
 ** module chunks = 73
 **/